import { Box, Button, Center, Image, Text, VStack } from '@chakra-ui/react';
import ChildHeader from 'components/Dashboard/Main/ChildHeader';
import React, { useContext } from 'react';
import Medica from '../../../images/modalPsicologo.svg';
import { getAppTheme } from 'components/Utils/theme';
import { AccountContext } from 'components/AccountContext';
import { useLocation } from 'react-router-dom';

function CancelamentoCallCenter() {
  const { user, page, setPage } = useContext(AccountContext);
  const theme = getAppTheme(user, { slug: 'DeoVita' });
  const { state } = useLocation();
  const exclusao = state?.exclusao;

  return (
    <>
      <ChildHeader />
      <VStack mt={'5%'}>
        <Box w={'100%'} p={5} mb={'-2em'}>
          <Center>
            <Image src={Medica} />
          </Center>
          <Text color={theme.color} fontSize={'18px'} m={5} textAlign={'center'} fontWeight={'bold'}>
            Para concluir {state?.exclusao ? 'sua exclusão' : 'seu cancelamento'}, você precisa entrar em contato com nosso Call Center
          </Text>
          <Button
            name="btn"
            color={theme?.fontcolor}
            bg={theme?.background}
            type="submit"
            w={{ base: '100%' }}
            borderRadius={'0.8em'}
            h={'2.2em'}
            onClick={async () => {
              const mensagem = `Olá, gostaria de ${exclusao ? 'excluir minha conta do app!' : 'cancelar meu contrato!'}`;
              const url = `https://wa.me/5508002802133?text=${encodeURIComponent(mensagem)}`;
              window?.open(url, '_blank');
            }}
          >
            Falar agora
          </Button>
        </Box>
      </VStack>
    </>
  );
}

export default CancelamentoCallCenter;
